<template>
    <div :class="['mb-2', {'white--text': dark}]">
        <h1>{{text}}</h1>
        <v-divider :dark="dark"></v-divider>
    </div>
</template>

<script>
    export default{
        name: 'WTitle',
        props: ['text', 'dark'],
    }
</script>

<style scoped>
    h1{
        font-weight: 200;
    }
</style>